import React, { useState } from 'react';

const BLOG_POSTS = [
    {
        id: 1,
        title: 'Comment migrer vers le cloud en 2024',
        excerpt: 'Guide complet pour migrer votre infrastructure vers le cloud sans interruption.',
        fullContent: `La migration vers le cloud est devenue essentielle pour les entreprises modernes. 
    Découvrez notre processus éprouvé pour migrer vos applications et données vers AWS, Azure ou Google Cloud.
    Nous couvrons : planification, sélection de la plateforme, migration des données, sécurité et optimisation des coûts.
    Nos experts gèrent chaque étape pour assurer une transition en douceur sans interruption de service.`,
        date: '15 Mars 2024',
        author: 'Babacar',
        category: 'Cloud',
        image: '☁️',
        readTime: '5 min'
    },
    {
        id: 2,
        title: 'Les meilleures pratiques de sécurité web',
        excerpt: 'Protégez votre application avec ces conseils de sécurité essentiels.',
        fullContent: `La sécurité web n'est pas optionnelle, c'est une nécessité. Dans cet article, nous explorons les meilleures pratiques
    pour protéger vos applications et données. Au programme : authentification forte, chiffrement, protection CSRF, SQL injection,
    XSS, gestion des mots de passe, mise à jour des dépendances et tests de sécurité réguliers.
    Suivez ces conseils pour maintenir votre application sécurisée contre les menaces modernes.`,
        date: '10 Mars 2024',
        author: 'Marie',
        category: 'Sécurité',
        image: '🔒',
        readTime: '7 min'
    },
    {
        id: 3,
        title: 'React 19: Les nouvelles features',
        excerpt: 'Découvrez les dernières améliorations et nouvelles fonctionnalités de React.',
        fullContent: `React 19 apporte des améliorations significatives pour les développeurs. Les principales nouveautés incluent :
    Actions Server, Directives, WebComponents améliorés, et bien d'autres. Nous explorons chaque feature en détail avec
    des exemples de code pratiques. Apprenez comment utiliser ces nouvelles capacités pour créer des applications
    React plus performantes et maintenables. De plus, découvrez les améliorations de performance et les optimisations.`,
        date: '5 Mars 2024',
        author: 'Néné',
        category: 'Développement',
        image: '⚛️',
        readTime: '8 min'
    },
    {
        id: 4,
        title: 'AI et Machine Learning dans les applications',
        excerpt: 'Intégrez l\'intelligence artificielle dans votre application web.',
        fullContent: `L'intelligence artificielle transforme la façon dont nous construisons les applications.
    De la recommandation de produits au chatbot IA, découvrez comment intégrer le ML dans vos projets.
    Nous couvrons : TensorFlow, PyTorch, APIs d'IA comme OpenAI, construction de modèles, déploiement et optimisation.
    Des cas d'usage réels montrent comment les entreprises utilisent l'IA pour améliorer l'expérience utilisateur
    et automatiser les processus métier.`,
        date: '28 Février 2024',
        author: 'Hamid',
        category: 'IA',
        image: '🤖',
        readTime: '6 min'
    },
    {
        id: 5,
        title: 'DevOps: Automatiser votre pipeline CI/CD',
        excerpt: 'Réduisez le time-to-market avec une bonne stratégie DevOps.',
        fullContent: `DevOps est la clé pour livrer rapidement et régulièrement. Découvrez comment mettre en place
    un pipeline CI/CD robuste avec Docker, Kubernetes, Jenkins et GitLab CI. Nous explorons l'infrastructure as Code,
    le monitoring, les logs, et la culture DevOps. Apprenez les erreurs courantes et comment les éviter.
    Optimisez votre processus de développement pour une productivité maximale et une qualité constante.`,
        date: '20 Février 2024',
        author: 'Babacar',
        category: 'DevOps',
        image: '🚀',
        readTime: '9 min'
    },
    {
        id: 6,
        title: 'MongoDB vs PostgreSQL: Le choix de la base de données',
        excerpt: 'Comparaison détaillée entre les bases de données relationnelles et non-relationnelles.',
        fullContent: `Choisir la bonne base de données est crucial pour votre application. MongoDB (NoSQL) et PostgreSQL (SQL)
    ont chacun leurs avantages et inconvénients. Nous comparons : structure des données, performance, scalabilité,
    sécurité, écosystème et coût. Découvrez quand utiliser MongoDB (données flexibles, haute scalabilité)
    versus PostgreSQL (données structurées, ACID compliance). Avec des exemples concrets et benchmarks.`,
        date: '15 Février 2024',
        author: 'Néné',
        category: 'Base de Données',
        image: '🗄️',
        readTime: '7 min'
    },
    {
        id: 7,
        title: 'TypeScript pour les entreprises modernes',
        excerpt: 'Pourquoi TypeScript est devenu le standard pour les applications d\'entreprise.',
        fullContent: `TypeScript apporte la sécurité des types à JavaScript, réduisant les bugs et améliorant la maintenabilité.
    Découvrez les avantages : détection d'erreurs à la compilation, meilleure documentation du code, refactoring sécurisé,
    et expérience de développement améliorée. Nous explorons les concepts clés : types, interfaces, génériques, décorateurs.
    Apprenez les meilleures pratiques pour les projets d'entreprise avec TypeScript, des patterns et des outils recommandés.`,
        date: '10 Février 2024',
        author: 'Marie',
        category: 'Développement',
        image: '📘',
        readTime: '6 min'
    },
    {
        id: 8,
        title: 'Comprendre l\'API REST vs GraphQL',
        excerpt: 'Quelle architecture choisir pour votre API ?',
        fullContent: `REST et GraphQL sont deux approches différentes pour construire des APIs. REST utilise les verbes HTTP
    et les endpoints fixes, tandis que GraphQL offre une interrogation flexible de vos données. Nous comparons :
    flexibilité, performance, mise en cache, sécurité, courbe d'apprentissage, et écosystème.
    Découvrez les cas où REST excelle et où GraphQL brille. Avec des exemples de code et des architectures récommandées.`,
        date: '5 Février 2024',
        author: 'Babacar',
        category: 'Développement',
        image: '🔗',
        readTime: '8 min'
    },
    {
        id: 9,
        title: 'Sécuriser vos API: CORS et authentification',
        excerpt: 'Les essentiels pour sécuriser vos endpoints API.',
        fullContent: `La sécurité des APIs est critique pour protéger votre application et les données de vos utilisateurs.
    Nous couvrons : CORS (Cross-Origin Resource Sharing), authentification JWT, OAuth2, rate limiting,
    validation des entrées, et HTTPS. Apprenez à implémenter ces mécanismes de sécurité correctement.
    Découvrez les erreurs courantes qui exposent vos APIs aux attaques et comment les prévenir.`,
        date: '30 Janvier 2024',
        author: 'Hamid',
        category: 'Sécurité',
        image: '🛡️',
        readTime: '7 min'
    }
];

export default function Blog() {
    const [selectedCategory, setSelectedCategory] = useState('Tous');
    const [selectedPost, setSelectedPost] = useState(null);

    const categories = ['Tous', 'Développement', 'Cloud', 'Sécurité', 'DevOps', 'IA', 'Base de Données'];

    const filteredPosts = selectedCategory === 'Tous'
        ? BLOG_POSTS
        : BLOG_POSTS.filter(post => post.category === selectedCategory);

    return (
        <div className="blog-page">
            <div className="container" style={{ paddingTop: '120px', minHeight: '100vh', paddingBottom: '4rem' }}>
                <div className="section-header">
                    <h1 style={{ fontSize: '3rem', marginBottom: '2rem' }}>Blog ApplicodeTech</h1>
                    <p style={{ fontSize: '1.2rem', color: '#9ca3af', maxWidth: '600px', margin: '0 auto' }}>
                        Actualités, guides et conseils sur les technologies IT, développement et startup
                    </p>
                </div>

                {/* Filtres Catégories */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    gap: '1rem',
                    marginBottom: '3rem'
                }}>
                    {categories.map(category => (
                        <button
                            key={category}
                            onClick={() => setSelectedCategory(category)}
                            style={{
                                padding: '0.5rem 1.25rem',
                                border: selectedCategory === category
                                    ? '2px solid #ff7e5f'
                                    : '1px solid rgba(97, 218, 251, 0.2)',
                                background: selectedCategory === category
                                    ? 'rgba(255, 126, 95, 0.1)'
                                    : 'transparent',
                                color: selectedCategory === category ? '#ff7e5f' : '#9ca3af',
                                borderRadius: '20px',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                fontSize: '0.95rem',
                                fontWeight: '500'
                            }}
                            onMouseEnter={(e) => {
                                if (selectedCategory !== category) {
                                    e.target.style.borderColor = '#ff7e5f';
                                    e.target.style.color = '#ff7e5f';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (selectedCategory !== category) {
                                    e.target.style.borderColor = 'rgba(97, 218, 251, 0.2)';
                                    e.target.style.color = '#9ca3af';
                                }
                            }}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                {/* Affichage du Post Détaillé ou Grille */}
                {selectedPost ? (
                    <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                        <button
                            onClick={() => setSelectedPost(null)}
                            style={{
                                background: 'transparent',
                                color: '#ff7e5f',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '1rem',
                                marginBottom: '2rem',
                                fontWeight: '600'
                            }}
                        >
                            ← Retour aux articles
                        </button>

                        <article style={{
                            background: 'rgba(255, 255, 255, 0.05)',
                            border: '1px solid rgba(97, 218, 251, 0.1)',
                            borderRadius: '10px',
                            overflow: 'hidden',
                            padding: '2rem'
                        }}>
                            <div style={{
                                fontSize: '4rem',
                                marginBottom: '1.5rem',
                                textAlign: 'center'
                            }}>
                                {selectedPost.image}
                            </div>

                            <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#fff' }}>
                                {selectedPost.title}
                            </h1>

                            <div style={{
                                display: 'flex',
                                gap: '1rem',
                                marginBottom: '2rem',
                                flexWrap: 'wrap',
                                borderBottom: '1px solid rgba(97, 218, 251, 0.1)',
                                paddingBottom: '1.5rem',
                                fontSize: '0.9rem',
                                color: '#9ca3af'
                            }}>
                                <span>📅 {selectedPost.date}</span>
                                <span>✍️ Par {selectedPost.author}</span>
                                <span>📍 {selectedPost.category}</span>
                                <span>⏱️ {selectedPost.readTime}</span>
                            </div>

                            <div style={{ color: '#d1d5db', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '2rem' }}>
                                {selectedPost.fullContent.split('\n').map((para, idx) => (
                                    <p key={idx} style={{ marginBottom: '1.5rem' }}>{para.trim()}</p>
                                ))}
                            </div>

                            <div style={{
                                background: 'rgba(255, 126, 95, 0.05)',
                                border: '1px solid rgba(255, 126, 95, 0.2)',
                                padding: '2rem',
                                borderRadius: '8px',
                                marginTop: '3rem'
                            }}>
                                <h3 style={{ color: '#ff7e5f', marginBottom: '1rem' }}>À propos de l'auteur</h3>
                                <p style={{ color: '#9ca3af' }}>
                                    {selectedPost.author} est un expert en technologie chez ApplicodeTech avec plusieurs années d'expérience
                                    dans le développement et l'architecture IT.
                                </p>
                            </div>
                        </article>
                    </div>
                ) : (
                    <>
                        {/* Grille Articles */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                            gap: '2rem'
                        }}>
                            {filteredPosts.length > 0 ? (
                                filteredPosts.map(post => (
                                    <article
                                        key={post.id}
                                        style={{
                                            background: 'rgba(255, 255, 255, 0.05)',
                                            border: '1px solid rgba(97, 218, 251, 0.1)',
                                            borderRadius: '10px',
                                            overflow: 'hidden',
                                            transition: 'all 0.3s ease',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => setSelectedPost(post)}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#ff7e5f';
                                            e.currentTarget.style.transform = 'translateY(-5px)';
                                            e.currentTarget.style.background = 'rgba(255, 126, 95, 0.05)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = 'rgba(97, 218, 251, 0.1)';
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                        }}
                                    >
                                        <div style={{
                                            background: 'linear-gradient(135deg, rgba(255, 126, 95, 0.1), rgba(97, 218, 251, 0.1))',
                                            padding: '2rem',
                                            textAlign: 'center',
                                            fontSize: '3rem'
                                        }}>
                                            {post.image}
                                        </div>

                                        <div style={{ padding: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                            <div style={{ marginBottom: '1rem' }}>
                        <span style={{
                            background: 'rgba(255, 126, 95, 0.1)',
                            color: '#ff7e5f',
                            padding: '0.25rem 0.75rem',
                            borderRadius: '20px',
                            fontSize: '0.8rem',
                            fontWeight: '600'
                        }}>
                          {post.category}
                        </span>
                                            </div>

                                            <h3 style={{
                                                fontSize: '1.3rem',
                                                marginBottom: '0.75rem',
                                                color: '#fff',
                                                lineHeight: '1.4'
                                            }}>
                                                {post.title}
                                            </h3>

                                            <p style={{
                                                color: '#9ca3af',
                                                marginBottom: '1.5rem',
                                                flex: 1,
                                                lineHeight: '1.6'
                                            }}>
                                                {post.excerpt}
                                            </p>

                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                borderTop: '1px solid rgba(97, 218, 251, 0.1)',
                                                paddingTop: '1rem',
                                                fontSize: '0.85rem',
                                                color: '#6b7280'
                                            }}>
                                                <span>{post.date}</span>
                                                <span>Par {post.author}</span>
                                            </div>
                                        </div>
                                    </article>
                                ))
                            ) : (
                                <div style={{ gridColumn: '1 / -1', textAlign: 'center', color: '#9ca3af', padding: '3rem' }}>
                                    Aucun article trouvé pour cette catégorie. Restez à l'affût pour plus de contenu !
                                </div>
                            )}
                        </div>

                        {/* Section Newsletter */}
                        <div style={{
                            marginTop: '4rem',
                            maxWidth: '600px',
                            margin: '4rem auto 0',
                            padding: '3rem',
                            background: 'rgba(97, 218, 251, 0.05)',
                            border: '1px solid rgba(97, 218, 251, 0.2)',
                            borderRadius: '10px',
                            textAlign: 'center'
                        }}>
                            <h3 style={{ color: '#61DAFB', marginBottom: '1rem', fontSize: '1.5rem' }}>
                                📬 Restez Informé
                            </h3>
                            <p style={{ color: '#9ca3af', marginBottom: '1.5rem' }}>
                                Abonnez-vous à notre newsletter pour recevoir les derniers articles et conseils directement dans votre email.
                            </p>
                            <form style={{ display: 'flex', gap: '1rem' }}>
                                <input
                                    type="email"
                                    placeholder="votre@email.com"
                                    style={{
                                        flex: 1,
                                        padding: '0.75rem',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        border: '1px solid rgba(97, 218, 251, 0.2)',
                                        borderRadius: '6px',
                                        color: '#fff'
                                    }}
                                />
                                <button
                                    type="submit"
                                    style={{
                                        background: '#ff7e5f',
                                        color: '#fff',
                                        border: 'none',
                                        padding: '0.75rem 1.5rem',
                                        borderRadius: '6px',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.background = '#ff6a48';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.background = '#ff7e5f';
                                    }}
                                >
                                    S'abonner
                                </button>
                            </form>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}